import { RichText } from 'components/rich-text/RichText';
import { PowerPackageType } from 'pages/api/get-power-packages';

import { PrismicImage } from '@prismicio/react';

import cx from 'classnames';

import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import styles from './PowerPackageCard.module.scss';
import LightningButton from 'components/new-buttons/LightningButton';
import SmallPowerPackageCard from './SmallPowerPackageCard';
import TransparentLink from 'components/new-buttons/TransparentLink';
import {
  formatPowerPackageTitle,
  formatPricesOnPackages,
  hasPackageTwoPrices,
} from 'utils/powerPackageHelper';
import {
  powerPackageDataUnit,
  chargePackageDataUnit,
} from 'components/prices/PricesOfPackagesList';

interface PowerPackageCardProps {
  item: PowerPackageType;
  isSmallSingleLine?: boolean;
  isChargePackage?: boolean;
  greyTheme?: boolean;
}

const PowerPackageCard = (props: PowerPackageCardProps) => {
  const { formatMessage } = useIntl();
  const { item, isSmallSingleLine = false, isChargePackage = false } = props;

  const shouldBeStrikedThrough = hasPackageTwoPrices(item.first_price_title);
  const [currentUid, setCurrentUid] = useState<string>('');

  useEffect(() => {
    setCurrentUid(getCurrentUid());
  }, []);

  const getCurrentUid = () => {
    const url = window.location.href;
    const urlSplit = url.split('/');
    const currentUid = urlSplit[urlSplit.length - 1];
    return currentUid;
  };

  const { preTitle, postTitle } = formatPowerPackageTitle(item.package_name);

  const onThisPackage = item._meta.uid.indexOf(currentUid) > -1;

  const priceText = ['Verð', 'Price'];

  if (isSmallSingleLine) {
    return (
      <SmallPowerPackageCard
        item={item}
        shouldBeStrikedThrough={shouldBeStrikedThrough}
        preTitle={preTitle}
        postTitle={postTitle}
        onThisPackage={onThisPackage}
      />
    );
  }

  return (
    <div className={styles.cardWrapper}>
      <div className={cx(styles.card, { [styles.greenBorder]: onThisPackage })}>
        <div className={styles.topWrapper}>
          <PrismicImage
            field={item.package_image}
            className={styles.packageImage}
          />

          <h3 className={styles.packageName}>
            <b>{preTitle}</b>
            {postTitle}
          </h3>
        </div>

        <div
          className={cx(styles.contentWrapper, {
            [styles.greyTheme]: props.greyTheme,
          })}
        >
          <RichText className={styles.description}>{item.description}</RichText>

          <div className={styles.bottomWrapper}>
            <div className={styles.priceWrapper}>
              {[
                {
                  price: item.package_first_price,
                  title: priceText.includes(item.first_price_title)
                    ? ''
                    : item.first_price_title,
                },
                {
                  price: item.package_second_price,
                  title: priceText.includes(item.second_price_title)
                    ? ''
                    : item.second_price_title,
                },
              ].map(
                (priceData, index) =>
                  priceData.price && (
                    <span key={index} className={styles.price}>
                      {priceData.title && (
                        <span className={styles.priceName}>
                          {priceData.title}
                        </span>
                      )}
                      <span
                        className={cx(styles.priceValue, {
                          [styles.withTitle]: priceData.title,
                        })}
                      >
                        {formatPricesOnPackages(
                          priceData.price,
                          isChargePackage
                        )}{' '}
                      </span>
                      <span className={styles.priceUnit}>
                        {isChargePackage
                          ? chargePackageDataUnit
                          : powerPackageDataUnit}
                      </span>
                    </span>
                  )
              )}
            </div>
            <div className={styles.buttonWrapper}>
              {item.skoda && (
                <TransparentLink
                  link={item.skoda}
                  text={formatMessage({
                    id: 'view',
                    defaultMessage: 'Skoða',
                  })}
                />
              )}
              {item.velja && (
                <LightningButton
                  link={item.velja}
                  text={
                    item.linkText ??
                    formatMessage({
                      id: 'sign_up',
                      defaultMessage: 'Velja',
                    })
                  }
                  metaUid={item._meta.uid}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PowerPackageCard;
